module.exports = __webpack_public_path__ + "img/fiskeri_akvakultur_paavirkning_vannuttak_hymo.c4bf1a24.jpg";